<template>
  <div class="uk-grid uk-grid-small" data-uk-grid>
    <a href="#" @click.prevent="openModal" class="uk-padding-remove uk-width-expand" v-if="type === 'icon'">
      <span class="uk-padding-remove uk-icon">
        <svg height="60" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg">   <path d="M218.17 424.14c-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34c-6.37 12.78-25.03 11.37-29.48-2.09L144 386.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.75-16.19 54.06-9.7 66 14.16 1.89 3.78 5.49 5.95 9.36 6.26v-82.12l128-127.09V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-40l-128-.11c-16.12-.31-30.58-9.28-37.83-23.75zM384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1zm-96 225.06V416h68.99l161.68-162.78-67.88-67.88L288 346.96zm280.54-179.63l-31.87-31.87c-9.94-9.94-26.07-9.94-36.01 0l-27.25 27.25 67.88 67.88 27.25-27.25c9.95-9.94 9.95-26.07 0-36.01z"></path> </svg>  
      </span><br>
      Finanzierung
    </a>
    <div class="uk-width-1-1" v-else>
      <button class="uk-button uk-width-1-1 uk-button-primary" @click.prevent="openModal">
        Finanzierungsrechner
      </button>
    </div>
    <div ref="modal" data-uk-modal="bg-close: false">
      <div class="uk-modal-dialog">
        <button class="uk-modal-close-default" type="button" uk-close></button>
          <div class="uk-modal-header">
            <h2 class="uk-modal-title">
              Finanzierungsrechner
            </h2>
          </div>
          <div class="uk-modal-body">
              <div class="uk-grid uk-grid-small" data-uk-grid>
                <div class="uk-width-1-1">
                  <p>Fahrzeug: {{ vehicle }} <br>
                  Kaufpreis: <strong>{{ price }} €</strong></p>
                </div>
                <div class="uk-width-1-1">
                  <div class="uk-margin uk-grid-small uk-child-width-auto uk-grid">
                    <label>
                      <input class="uk-radio" type="radio" v-model="type" value="3-way"> Finanzierung mit Schlussrate
                    </label>
                    <label><input class="uk-radio" type="radio" v-model="type" value="default"> Standardfinanzierung</label>
                </div>
                </div>
                <div class="uk-width-1-1">
                  <div class="uk-margin">
                    <label class="uk-text-bold">Anzahlung</label>
                    <input type="text" class="uk-input" v-model="deposit">
                  </div>
                  <div class="uk-margin">
                    <label class="uk-text-bold">Laufzeit</label>
                    <div class="uk-flex uk-flex-between uk-margin-small-bottom">
                      <div>
                        {{ runtime }} Monate
                      </div>
                    </div>
                    <vue-slider
                      v-model="runtime"
                      :min="12"
                      :max="maxRuntime"
                      :tooltip="'none'"
                      @drag-end="onDragEnd"
                      :interval="12"
                      :drag-on-click="true"
                      :enable-cross="false"
                      ></vue-slider>
                    <!--<v-select :clearable="false" :options="runtimeOptions" v-model="runtime"></v-select>-->
                  </div>
                  <div class="uk-margin">
                    Finanzierungsbetrag: <span class="uk-text-bold">{{ formattedFinancialPrice }}</span><br>
                    eff. Jahreszins: <span class="uk-text-bold">{{ formattedPercent }}</span>
                  </div>
                </div>
                <div class="uk-width-1-1">
                  <div class="uk-flex uk-flex-center">
                    <div class="uk-width-large uk-section uk-flex uk-flex-center uk-section-xsmall uk-section-primary uk-border-rounded">
                      <div v-if="sending" data-uk-spinner="ratio: 0.93"></div>
                      <div v-else class="uk-text-bold uk-h4">Voraussichtliche Monatsrate: {{ rate }} €</div>
                    </div>
                  </div>
                   <div class="uk-flex uk-flex-center uk-margin-small-top" v-if="type === '3-way' && closingRate !== 0">
                      <p class="uk-margin-remove">zzgl. Schlussrate: <span class="uk-text-bold">{{ formattedClosingRate }}</span></p>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
</template>

<script>
import vSelect from 'vue-select'
import axios from 'axios'
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import { debounce } from 'lodash'
  export default {
    props: {
      vehicle: {
        type: String,
        required: true
      },
      price: {
        required: true
      },
      settings: {
        required: false,
        type: Object,
        default: () => {
          return {
            type: '3-way',
            runtime: 48,
            deposit: 0
          }
        }
      }
    },
    components: {
      vSelect,
      VueSlider
    },
    data() {
      return {
        type: this.settings.type,
        sending: true,
        interestRate: JSON.parse(window.kfzFinancial).interestRate || 1.99,
        runtime: this.settings.runtime,
        rate: 0,
        closingRate: 0,
        dispositAmount: 0
      }
    },
    mounted() {
      const querystring = window.location.search.substring(1);
      if(querystring === 'finanz') {
        setTimeout(() => {this.openModal()},500)
      }
    },
    computed: {
      formattedPercent() {
        return this.interestRate.toString().replace('.', ',') + '%'
      },
      formattedFinancialPrice() {
        const nf = new Intl.NumberFormat(['de-DE'], {
          style: 'currency',
          currency: 'EUR',
          maximumSignificantDigits: 6
        });

        return nf.format(this.financialPrice)
      },
      formattedClosingRate() {
        const nf = new Intl.NumberFormat(['de-DE'], {
          style: 'currency',
          currency: 'EUR',
          maximumSignificantDigits: 6
        });

        return nf.format(this.closingRate)
      },
      maxRuntime() {
        return this.type === '3-way' ? 60 : 96
      },
      financialPrice() {
        return this.price.replace('.','') - parseFloat(this.deposit || 0)
      },
      deposit: {
        get() {

          if(this.dispositAmount) {
            return this.dispositAmount
          }

          if(this.settings.deposit.toString().includes('%')) {
            const price = parseFloat(this.price.replace('.',''))
            const amount = (price * parseFloat(this.settings.deposit.replace('%','')) / 100).toFixed()

            // round to full hundred
            return Math.round(amount /100 ) * 100
          }
          if(this.settings.deposit.toString() !== '0') {
            return parseFloat(this.settings.deposit)
          }
        },
        set (newValue) {
          this.dispositAmount = newValue
        }

      }
    },
    watch: {
      type() {
        this.sending = true
        this.getRate()
      },
      dispositAmount() {
        this.sending = true
        this.getRate()
      }
    },
    methods: {
      getRate: debounce(function() {
        axios.post('/wp-json/ansolution/v1/webkfz/financial-rate', {
          interestRate: this.interestRate.toString().replace(',', '.'),
          runtime: this.runtime,
          amount: this.financialPrice,
          fullAmount: this.price.replace('.',''),
          type: this.type
        }).then(response => {
          this.rate = response.data.rate
          this.closingRate = response.data.closingRate
          this.sending = false
        })
      }, 1000),
      onDragEnd() {
        this.sending = true
        this.getRate()
      },
      openModal() {
        UIkit.modal(this.$refs.modal).show();
        this.getRate()
      }
    }  
  }
</script>